import { EXCEL_STYLES } from '../constants.js';
import { applyCellStyle } from '../utils/excel-helpers.js';
import { createHeaderStyle } from '../utils/colors.js';

export const createWBSHeaderRow = (worksheet, rowNum, flatColumns, columnHeaders, maxNestingLevel, nameColumnIndex, colorMap) => {
  const headerRow = worksheet.getRow(rowNum);
  let currentCol = 1;

  const headerStyle = createHeaderStyle(colorMap);

  flatColumns.forEach((column, index) => {
    if (index === nameColumnIndex) {
      for (let i = 0; i < maxNestingLevel; i++) {
        const cell = headerRow.getCell(currentCol);
        cell.value = '';
        applyCellStyle(cell, {
          fill: headerStyle.fill,
          border: headerStyle.border
        });
        worksheet.getColumn(currentCol).width = 6;
        currentCol++;
      }
    }

    const header = columnHeaders[index];
    const cell = headerRow.getCell(currentCol);
    cell.value = header.value;

    if (header.style) applyCellStyle(cell, header.style);
    if (column.colWidth) worksheet.getColumn(currentCol).width = column.colWidth;

    if (header.colSpan && header.colSpan > 1) {
      worksheet.mergeCells(rowNum, currentCol, rowNum, currentCol + header.colSpan - 1);
    }

    currentCol++;
  });

  return headerRow;
};

export const createFlatHeaderRow = (worksheet, rowNum, columnHeaders, flatColumns) => {
  const headerRow = worksheet.getRow(rowNum);

  columnHeaders.forEach((header, index) => {
    const cell = headerRow.getCell(index + 1);
    cell.value = header.value;

    if (header.style) applyCellStyle(cell, header.style);

    const columnDef = flatColumns[index];
    if (columnDef && columnDef.colWidth) {
      worksheet.getColumn(index + 1).width = columnDef.colWidth;
    }

    if (header.colSpan && header.colSpan > 1) {
      worksheet.mergeCells(rowNum, index + 1, rowNum, index + header.colSpan);
    }
  });

  return headerRow;
};

export const createGroupedHeaderRow = (worksheet, rowNum, flatColumns, columnHeaders, maxNestingLevel, nameColumnIndex, colorMap) => {
  const headerRow = worksheet.getRow(rowNum);
  let currentCol = 1;

  const headerStyle = createHeaderStyle(colorMap);

  if (maxNestingLevel > 1 && nameColumnIndex >= 0) {
    for (let col = 1; col <= maxNestingLevel; col++) {
      const cell = headerRow.getCell(col);
      cell.value = '';
      applyCellStyle(cell, {
        fill: headerStyle.fill,
        border: headerStyle.border
      });
      worksheet.getColumn(col).width = 6;
    }
    currentCol = maxNestingLevel + 1;
  }

  columnHeaders.forEach((header, index) => {
    const cell = headerRow.getCell(currentCol + index);
    cell.value = header.value;

    if (header.style) applyCellStyle(cell, header.style);

    const columnDef = flatColumns[index];
    if (columnDef && columnDef.colWidth) {
      worksheet.getColumn(currentCol + index).width = columnDef.colWidth;
    }

    if (header.colSpan && header.colSpan > 1) {
      worksheet.mergeCells(rowNum, currentCol + index, rowNum, currentCol + index + header.colSpan - 1);
    }
  });

  return headerRow;
};